const Flickity = require('flickity');

export default () => {
    const hero = document.querySelector('.hero');
    const header = document.querySelector('.header');
    const slider = document.querySelector('[data-hero-slider]');
    const downArrow = document.querySelector('[data-arrow]');
    const videos = document.querySelectorAll('[data-video-id]');

    if (slider) {
        const flickity = new Flickity(slider, {
            cellAlign: 'left',
            contain: true,
            prevNextButtons: false,
            pageDots: true,
        });
    }

    function checkHero() {
        if (window.scrollY >= hero.getBoundingClientRect().height - 70) {
            header.classList.add('past');
        } else {
            header.classList.remove('past');
        }
    }

    if (hero) {
        checkHero();

        window.addEventListener('scroll', () => {
            checkHero();
        });
    }

    if (downArrow) {
        downArrow.addEventListener('click', (e) => {
            e.preventDefault();
            const h = hero.getBoundingClientRect().height - 70;
            window.scroll(0, h);
            return false;
        });
    }

    if (videos.length) {

        const tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";

        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        window.onYouTubeIframeAPIReady = function() {
            function onPlayerReady(event) {
                event.target.playVideo();
            }

            for (const video of videos) {
                const videoId = video.getAttribute('data-video-id');
                const dom = document.createElement('div');
                video.append(dom);
                const player = new YT.Player(dom, {
                    videoId: videoId,
                    playerVars: {
                        'controls': 0,
                        'playlist': videoId,
                        'loop': 1,
                        'autoplay': true,
                        'mute': 1,
                    },
                    events: {
                        'onReady': function (e) {
                            onPlayerReady(e)
                        },
                    }
                });

            }
        };
    }
}
